export const getToken = () => {
  return localStorage.getItem("token");
};
export const getRefresh = () => {
  return localStorage.getItem("refresh");
};

export const saveToken = (token) => {
  localStorage.setItem("token", token);
};

export const saveRefresh = (token) => {
  localStorage.setItem("refresh", token);
};

export const destroyToken = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh");
  localStorage.removeItem("access_token");
  localStorage.removeItem("currentRole");
  localStorage.removeItem("employeeId");
};

export const getCurrentRole = () => {
  return parseInt(localStorage.getItem("currentRole")) || 1;
};

export default { getToken, getRefresh, saveToken, saveRefresh, destroyToken };
